/**
 * The zoom the map moves to when a turn is picked from the directions list.
 *
 * Only ever in, and only when the map is too far out to make a junction out at all. Picking
 * turns one after another used to reset the zoom to a fixed level each time, which pumped the
 * view in and out between clicks — and threw away wherever the planner had zoomed to look. At
 * or past the threshold the zoom is left alone and the camera just pans.
 */
export const TURN_FOCUS_MIN_ZOOM = 15.5;

export function turnFocusZoom(currentZoom: number): number {
  return Math.max(currentZoom, TURN_FOCUS_MIN_ZOOM);
}
